import React from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import "../styles/modalStyles.css";

const CustomYesNoModal = (props) => {
  const { title, isOpen, onClose, onSubmit } = props;

  return (
    <Modal open={isOpen} onClose={onClose} style={{}} className="add-modal">
      <div className="add-modal-content">
        <h3>{title}</h3>
        <div className="add-name">
          <Button variant="contained" color="primary" onClick={onSubmit}>
            Confirm
          </Button>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomYesNoModal;
